// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/tags_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsTagsData } from "./constants";
import type { AppSettingsTagsDataParams, AppSettingsTagsDataResult } from "./types";

export const getDataTableAppSettingsTagsData = reactQueryTableFetcherAdapter(
  appSettingsTagsData,
  async (
    signal: AbortSignal,
    { appGroupId, query, groupby, sortby, sortdir, limit = 20, start = 0 }: AppSettingsTagsDataParams
  ): Promise<AppSettingsTagsDataResult> => {
    const tags = await fetch(
      "/app_settings/tags_data",
      "GET",
      {
        groupby,
        query: serializeQueryObjects(query),
        limit,
        start,
        sortby,
        sortdir,
        app_group_id: appGroupId,
      },
      { signal }
    );
    tags.results.forEach((tag) => (tag.id = tag.name));
    return tags;
  }
);
